/**
 * VendorPortalProductVariantCategoryService
 * Read-only service for variant categories (global/system-wide).
 * Route: api/vendor-portal/variant-categories
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalProductVariantCategoryService
 * Read-only access to global variant categories for the vendor portal.
 * Maps to /api/vendor-portal/variant-categories endpoint
 */
export class VendorPortalProductVariantCategoryService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalProductVariantCategoryService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalProductVariantCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all active variant categories
     * GET /api/vendor-portal/variant-categories
     */
    async getCategories() {
        const response = await this.getCategoriesRaw();
        return response.data ?? [];
    }
    /**
     * Get all categories (raw response)
     */
    getCategoriesRaw() {
        return this.get();
    }
    // ==================== GET BY ID ====================
    /**
     * Get a specific category by ID
     * GET /api/vendor-portal/variant-categories/{id}
     */
    async getCategory(id) {
        const response = await this.getCategoryRaw(id);
        if (!response.data) {
            throw new Error(`Variant category with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific category (raw response)
     */
    getCategoryRaw(id) {
        return this.get(`${id}`);
    }
}
VendorPortalProductVariantCategoryService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorPortalProductVariantCategoryService.BASE_PATH = 'api/vendor-portal/variant-categories';
//# sourceMappingURL=VendorPortalProductVariantCategoryService.js.map